

export default [
  {
    url: '/students/list',
    name: "listadoEstudiantes",
    slug: "dashboard-ecommerce",
    tagColor: "warning",
    icon: "ListIcon",
    i18n: "ListadoEstudiantes",
  },
  {
    url: '/account/login',
    name: "accountLogin",
    slug: "dashboard-ecommerce",
    // tag: "24",
    tagColor: "warning",
    icon: "UserIcon",
    i18n: "MyAccount",
  },
  // {
  //   url: '/list/shop-products',
  //   name: "productosShop",
  //   slug: "dashboard-ecommerce",
  //   // tag: "24",
  //   tagColor: "warning",
  //   icon: "",
  //   i18n: "productosShop",
  // },
  {
    url: '/account/close',
    name: "closeSession",
    slug: "dashboard-ecommerce",
    // tag: "24",
    tagColor: "warning",
    icon: "UserIcon",
    i18n: "CloseSession",
  }
]

